module.exports = __webpack_public_path__ + "img/close-icon.fd545ed8.svg";